export default __webpack_public_path__ + "static/media/jason.789b2f9a.jpeg";